import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import YouTubeShort from '../../../components/YouTubeShort';
import FixedHeader from '../../../components/FixedHeader';
import SocialMedia from '../../../components/SocialMedia';
import GlassCard from '../../../components/GlassCard';

import './styles.css';

export default class HomeSmallSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsStatus: 'unknown'
    };
  }

  componentDidMount() {
    this.updateTermsStatus();
    window.addEventListener('termsStatusChange', this.updateTermsStatus);
  }

  componentWillUnmount() {
    window.removeEventListener('termsStatusChange', this.updateTermsStatus);
  }

  updateTermsStatus = () => {
    try {
      const storedValue = localStorage.getItem('termsStatus');
      const legacyValue = storedValue === null ? localStorage.getItem('termsAccepted') : null;
      const resolvedValue = storedValue ?? legacyValue;
      if (resolvedValue === 'accepted' || resolvedValue === 'true') {
        this.setState({ termsStatus: 'accepted' });
      } else if (resolvedValue === 'rejected') {
        this.setState({ termsStatus: 'rejected' });
      } else {
        this.setState({ termsStatus: 'unknown' });
      }
    } catch (error) {
      this.setState({ termsStatus: 'unknown' });
    }
  };

  render() {
    const { termsStatus } = this.state;
    const termsRejected = termsStatus === 'rejected';
    return (
      <Container fluid className="p-0" style={{ backgroundColor: 'var(--dashboard-bg)', minHeight: '100vh', color: 'var(--text)' }}>
        <FixedHeader />
        <Container className="px-4 pb-4" style={{ paddingTop: '110px' }}>
          <Row className="justify-content-center mb-4">
            <GlassCard className="disclaimer">
              <h4><b>Welcome to the lab!</b></h4>
              <br />
              Think of it as a mix between a workshop, a game room, and a mad scientist’s lab!
              <br />
              No rules, no limits... just ideas, experiments, and playful creations to explore.
              <br />
              <br />
              Stay tuned and remember: it's just for fun :)
            </GlassCard>
          </Row>

          <Row className="justify-content-center mb-4">
            <GlassCard className="disclaimer dashboard-card mb-0 w-100">
              <h4 className="text-center mb-3"><b>Latest Experiments</b></h4>
              <Row className="justify-content-center mb-4">
                <Col xs={12} className="px-2">
                  {termsRejected ? (
                    <div className="terms-blocked p-4 text-center">Accept terms to view videos.</div>
                  ) : (
                    <YouTubeShort url="https://youtube.com/shorts/AVBRiYyVmi4" />
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center mb-4">
                <Col xs={12} className="px-2">
                  {termsRejected ? (
                    <div className="terms-blocked p-4 text-center">Accept terms to view videos.</div>
                  ) : (
                    <YouTubeShort url="https://youtube.com/shorts/lFJ40_L4jAk" />
                  )}
                </Col>
              </Row>
              <Row className="justify-content-center mb-4">
                <Col xs={12} className="px-2">
                  {termsRejected ? (
                    <div className="terms-blocked p-4 text-center">Accept terms to view videos.</div>
                  ) : (
                    <YouTubeShort url="https://youtube.com/shorts/MyrWILMEyXc" />
                  )}
                </Col>
              </Row>
            </GlassCard>
          </Row>
        </Container>
        <SocialMedia isSmall={true} />
      </Container>
    );
  }
}
